import React, { useState } from 'react';
import './InfoSection.css';

const InfoSection: React.FC = () => {
  const [openBlock, setOpenBlock] = useState<number | null>(null);

  const toggleBlock = (blockNumber: number) => {
    setOpenBlock(openBlock === blockNumber ? null : blockNumber);
  };

  return (
    <section className="info-section">
      <div className="info-content">
        <div className="expandable-blocks">
          <div className={`expandable-block ${openBlock === 0 ? 'open' : ''}`} id="conditions">
            <div className="block-header">
              <h3>ВОЗРАСТ УЧАСТНИКОВ</h3>
              <button 
                className="expand-button"
                onClick={() => toggleBlock(0)}
              >
                {openBlock === 0 ? 'свернуть' : 'подробнее'}
              </button>
            </div>
            <div className="block-content">
              <p>В официальный зачёт пойдут результаты только лиц соответствующего возраста (12 – 17 лет), в остальных случаях результат не засчитывается. В случае, если Вы выходите в финал, организаторы попросят документально подтвердить возраст.</p>
            </div>
          </div>

          <div className={`expandable-block ${openBlock === 1 ? 'open' : ''}`}>
            <div className="block-header">
              <h3>ФИНАНСИРОВАНИЕ КОНКУРСА</h3>
              <button 
                className="expand-button"
                onClick={() => toggleBlock(1)}
              >
                {openBlock === 1 ? 'свернуть' : 'подробнее'}
              </button>
            </div>
            <div className="block-content">
              <p>Финансирование проведения Конкурса, питания участников на площадке и спецодежды осуществляется за счет Организатора.</p>
              <p>Расходы на дорогу до места проведения Конкурса и обратно, проживание и питание вне расписания Конкурса обеспечиваются направляющей стороной.</p>
            </div>
          </div>

          <div className={`expandable-block ${openBlock === 2 ? 'open' : ''}`}>
            <div className="block-header">
              <h3>КАК БУДЕМ ЖЮРИТЬ</h3>
              <button 
                className="expand-button"
                onClick={() => toggleBlock(2)}
              >
                {openBlock === 2 ? 'свернуть' : 'подробнее'}
              </button>
            </div>
            <div className="block-content">
              <p>Победитель и призеры определяются по результатам независимой экспертизы полученных продуктов с помощью физико-химических методов анализа (рентгено-фазовый анализ и измерением квантового выхода люминесценции) в сторонней организации.</p>
            </div>
          </div>

          <div className={`expandable-block ${openBlock === 3 ? 'open' : ''}`}>
            <div className="block-header">
              <h3>СЕРТИФИКАТЫ И ДИПЛОМЫ</h3>
              <button 
                className="expand-button"
                onClick={() => toggleBlock(3)}
              >
                {openBlock === 3 ? 'свернуть' : 'подробнее'}
              </button>
            </div>
            <div className="block-content">
              <p>Электронные именные сертификаты получают все участники команд, выполнившие более 50% заданий первого теоретического тура. Эти сертификаты являются подтверждением успешного прохождения начального этапа и демонстрируют уровень знаний и навыков, необходимых для дальнейшего участия в конкурсах.</p>
              <p>Сертификатами очного этапа награждаются все команды-финалисты, допущенные к очному этапу конкурса. Такой сертификат подтверждает статус участника финала и может быть полезен для профессионального портфолио или дальнейшей учебы и работы в области нанотехнологий.</p>
              <p>Дипломами победителей и призеров, а также ценными призами отмечаются участники команд, занявшие 1-е, 2-е и 3-е места.</p>
              <p>Мы гордимся каждым участником и стремимся предоставить достойное признание их успехам и достижениям в ходе конкурса!</p>
            </div>
          </div>

          <div className={`expandable-block ${openBlock === 4 ? 'open' : ''}`}>
            <div className="block-header">
              <h3>ВСЕРОССИЙСКИЙ ХАКАТОН ПО НАНОТЕХНОЛОГИЯМ 2025. КАК ЭТО БЫЛО?</h3>
              <button
                className="expand-button"
                onClick={() => toggleBlock(4)}
              >
                {openBlock === 4 ? 'свернуть' : 'подробнее'}
              </button>
            </div>
            <div className="block-content">
              <ul className="block-links">
                <li>
                  <a href="https://smotrim.ru/video/3043945" target="_blank" rel="noopener noreferrer">
                    Вести Красноярск
                  </a>
                </li>
                <li>
                  <a href="https://vk.com/kvantorium24?w=wall-135388741_8236" target="_blank" rel="noopener noreferrer">
                    Пост Вконтакте
                  </a>
                </li>
                <li>
                  <a href="https://vkvideo.ru/video-48690112_456279471" target="_blank" rel="noopener noreferrer">
                    Телеканал Енисей
                  </a>
                </li>
                <li>
                  <a href="https://vkvideo.ru/video-17355786_456255250" target="_blank" rel="noopener noreferrer">
                    Прима
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InfoSection;
